import React from 'react';
import {connect} from 'react-redux';
import {Container} from 'reactstrap';
import {requestDirectory} from '../../actions/directoryActions';
import {requestHistory} from '../../actions/historyActions';
import PropertySelector from './PropertySelector';
import {isHistoryLoaded} from '../../services/utils';
import Loader from '../Loader';
import Chart from '../Chart';

const prepareSamples = (data) => data.samples.map((s) => ([new Date(s.date).getTime(), s.value]));

const buildOptions = (paths, history) => {
    paths = paths.filter((p) => !!p && isHistoryLoaded(history[p]));
    return {
        chart: {type: 'spline'},
        title: {text: ''},
        xAxis: {minTickInterval: 60 * 60 * 24, type: 'datetime'},
        yAxis: {minTickInterval: 1, title: {enabled: false}},
        series: paths.map((path) => ({
            data: prepareSamples(history[path].data),
            name: path,
            zoneAxis: 'x',
        })),
    };
};

class History extends React.Component {
    constructor(props) {
        super(props);
        this.load = this.load.bind(this);
        this.setPath = this.setPath.bind(this);
        this.setRange = this.setRange.bind(this);

        const range = 30;
        const from = new Date();
        from.setDate(from.getDate() - range);
        const to = new Date();

        this.state = {
            from, to, range,
            paths: ['', '', '', '', ''],
        };
    }

    componentDidMount() {
        if (!this.props.directory) {
            this.props.requestDirectory();
        }
    }

    setPath(index, path) {
        const paths = this.state.paths.slice(0);
        paths[index] = path;
        this.setState({paths}, () => this.load());
    }

    setRange(e) {
        const range = Number(e.target.value);
        const from = new Date();
        from.setDate(from.getDate() - range);
        const to = new Date();
        this.setState({range: Number(range), from, to}, () => this.load());
    }

    load() {
        const paths = this.state.paths.filter((path) => !!path);
        if (paths.length > 0) {
            for (let i = 0; i < paths.length; i++) {
                const [node, property] = paths[i].split('/');
                this.props.requestHistory(paths[i], node, property, {from: this.state.from, to: this.state.to});
            }
        }
    }

    render() {
        const {directory, historyData} = this.props;
        return (
            <Container>
                <h1>History</h1>
                {directory && <React.Fragment>
                    {this.state.paths.map((path, index) =>
                        <PropertySelector key={index}
                            nodes={directory.nodes}
                            index={index} onChange={this.setPath} value={path} />)}
                    <select value={'' + this.state.range} onChange={this.setRange} className="form-control mb-3">
                        <option value="7">Last 7 days</option>
                        <option value="30">Last 30 days</option>
                        <option value="180">Last 6 months</option>
                    </select>

                    {this.state.paths.some((p) => !!p) && (
                        <React.Fragment>
                            {isHistoryLoaded(this.state.paths[0] /* TODO */) && <Chart options={buildOptions(this.state.paths, historyData)} /> || <Loader />}
                        </React.Fragment>
                    )}
                </React.Fragment>}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    directory: state.directory.data,
    historyData: state.history.data,
});

export default connect(mapStateToProps, {requestDirectory, requestHistory})(History);
